export default __webpack_public_path__ + "static/media/socket.1574390c.svg";